import type ApiLoyaltyCard from 'src/core/models/api/ApiLoyaltyCard';
import Constants from 'src/core/utils/Constants';
import Translations from 'src/core/utils/Translations';
import { useLeaveAppStore } from 'src/domain/stores/useLeaveAppStore';
import { useLoyaltyStore } from 'src/domain/stores/useLoyaltyStore';
import { useServicesStore } from 'src/domain/stores/useServicesStore';

// The grid card and the detail sheet offer the same benefit, so the label rules and the redeem
// route live here instead of in both of them.
export const useBenefitCta = (card: ApiLoyaltyCard) => {
	const { captureEvent } = useServicesStore();
	const { confirmLeaving } = useLeaveAppStore();
	const { openResortPicker } = useLoyaltyStore();

	const redeemCode = () => {
		if (!card.workspaces || card.workspaces.length === 0) {
			return;
		}

		if (card.workspaces.length > 1) {
			openResortPicker(card);

			return;
		}

		const url = card.workspaces[0]?.reservation_flow_url;

		if (!url) {
			captureEvent({ message: 'Redeeming a loyalty card without a reservation flow url', extra: { code: card.code } });

			return;
		}

		confirmLeaving({
			url,
			description: Translations.reserveLeaveAppDescription,
			webMessage: Constants.bridgeMessageReservationFlowOpen,
		});
	};

	const editorialLabel =
		card.alternative_cta === true && card.alternative_cta_button_text
			? card.alternative_cta_button_text
			: card.download_url
				? Translations.loyaltyDownloadVoucher
				: null;

	const redeem = () => {
		if (card.no_cta === true) {
			return;
		}

		if (card.alternative_cta === true && card.alternative_cta_button_url) {
			confirmLeaving({ url: card.alternative_cta_button_url });

			return;
		}

		if (card.download_url) {
			confirmLeaving({ url: card.download_url });

			return;
		}

		redeemCode();
	};

	return { editorialLabel, redeem };
};
